"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylePermissionsPreview = exports.MenuButtons = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var BlockStore_1 = __importDefault(require("Project/Stores/BlockStore"));
var lodash_1 = require("lodash");
var StyleButton_1 = require("Project/BlockNew/Menu/Settings/StyleButton/StyleButton");
var commonBlockOptions_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonBlockOptions");
var CssEditor_1 = __importDefault(require("../../StyleShortcut/CssEditor/CssEditor"));
var CommonTextShortcut_1 = __importDefault(require("../../StyleShortcut/CommonTextShortcut/CommonTextShortcut"));
var CommonBlockStyleShortcut_1 = __importDefault(require("../../StyleShortcut/CommonBlockStyleShortcut/CommonBlockStyleShortcut"));
var MotionShortcut_1 = __importDefault(require("../../StyleShortcut/MotionShortcut/MotionShortcut"));
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var StyleShortCutContainer_1 = __importDefault(require("../../../Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var StyleBuilder_util_spec_1 = require("Test/Builders/StyleBuilder.util.spec");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("DataStores/Account/Types");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
exports.MenuButtons = (0, mobx_react_1.observer)(function (_a) {
    var shouldShowBlockStyleButton = _a.shouldShowBlockStyleButton, shouldShowBlockBackgroundStyleButton = _a.shouldShowBlockBackgroundStyleButton, blockStore = _a.blockStore, brandStore = _a.brandStore;
    return (react_1.default.createElement("section", { className: "block-menu" },
        react_1.default.createElement("div", { className: "menu-container" },
            react_1.default.createElement("div", { className: "main-menu top-item closed" },
                react_1.default.createElement("div", { className: "menu-toolbar" },
                    react_1.default.createElement("div", { className: "expando-button round-button" },
                        react_1.default.createElement("div", { className: "icon" },
                            react_1.default.createElement(icons_1.OptionsHorizontal, null))))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "round-button top-item round-button--overflow" },
                    react_1.default.createElement("div", { className: "top-button-ui ng-isolate-scope top-button-ui--overflow" },
                        react_1.default.createElement(StyleButton_1.StyleButtonWrapper, { brandStore: brandStore, blockStore: blockStore, shouldShowBlockStyleButton: shouldShowBlockStyleButton, shouldShowBlockBackgroundStyleButton: shouldShowBlockBackgroundStyleButton, onBlockStyleButtonClick: lodash_1.noop, onLibraryClick: lodash_1.noop, isLastBlock: function () { return false; } })))))));
});
var StylePermissionsPreview = (function (_super) {
    __extends(StylePermissionsPreview, _super);
    function StylePermissionsPreview(props) {
        var _this = _super.call(this, props) || this;
        _this.renderSampleStyleShortcut = function () {
            var stylePermissionStore = _this.props.stylePermissionStore;
            var withBlockStyle = stylePermissionStore.isStyleAccessOn(Types_1.StyleAccessType.Block);
            var withTextStyle = stylePermissionStore.isStyleAccessOn(Types_1.StyleAccessType.Text);
            var withMotion = stylePermissionStore.isStyleAccessOn(Types_1.StyleAccessType.Motion);
            var withCSS = stylePermissionStore.isAdvancedStyleEnabled && stylePermissionStore.isStyleAccessOn(Types_1.StyleAccessType.CSS);
            var mockTelemetry = {
                track: lodash_1.noop,
            };
            return (react_1.default.createElement(StyleShortCutContainer_1.default, { lowPadding: true },
                react_1.default.createElement(kaleidoscope_1.Tabs, null,
                    react_1.default.createElement(kaleidoscope_1.TabList, { isBordered: true, "aria-label": "Style options", align: kaleidoscope_1.TabListAlign.Center },
                        withBlockStyle && react_1.default.createElement(kaleidoscope_1.Tab, null, "Block"),
                        withTextStyle && react_1.default.createElement(kaleidoscope_1.Tab, null, "Text"),
                        withMotion && react_1.default.createElement(kaleidoscope_1.Tab, null, "Animate"),
                        withCSS && react_1.default.createElement(kaleidoscope_1.Tab, null, "CSS")),
                    react_1.default.createElement(kaleidoscope_1.TabPanels, { transitionHeight: true },
                        withBlockStyle && _this.renderBlockSettings(mockTelemetry),
                        withTextStyle && _this.renderTextSettings(mockTelemetry),
                        withMotion && _this.renderMotionSettings(mockTelemetry),
                        withCSS && _this.renderCssSettings()))));
        };
        _this.renderBlockSettings = function (mockTelemetry) {
            var _a = _this.props, brandStore = _a.brandStore, usingFeature = _a.usingFeature;
            return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                react_1.default.createElement("div", { className: "style-shortcut__main" },
                    react_1.default.createElement(CommonBlockStyleShortcut_1.default, { handleBackgroundChange: lodash_1.noop, openBrandSetup: lodash_1.noop, blockWidthOptions: commonBlockOptions_1.blockWidthOptions, blockSpacingOptions: commonBlockOptions_1.blockSpacingOptions, blockHeightOptions: commonBlockOptions_1.blockHeightOptions, brandStore: brandStore, telemetry: mockTelemetry, blockStore: _this.sampleBlockStore, usingFeature: usingFeature }))));
        };
        _this.renderTextSettings = function (mockTelemetry) {
            var brandStore = _this.props.brandStore;
            return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                react_1.default.createElement("div", { className: "style-shortcut__main" },
                    react_1.default.createElement(CommonTextShortcut_1.default, { colors: brandStore.colorsWithThemeIndex, blockStore: _this.sampleBlockStore, telemetry: mockTelemetry }))));
        };
        _this.renderMotionSettings = function (mockTelemetry) {
            return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                react_1.default.createElement("div", { className: "style-shortcut__main" },
                    react_1.default.createElement(MotionShortcut_1.default, { blockStore: _this.sampleBlockStore, telemetry: mockTelemetry }))));
        };
        _this.renderCssSettings = function () {
            return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                react_1.default.createElement("div", { className: "style-shortcut__main" },
                    react_1.default.createElement(CssEditor_1.default, { blockStyleStore: _this.sampleBlockStore.blockStyleStore }))));
        };
        _this.getSampleBlockStore = function () {
            var colors = _this.props.brandStore.colors;
            var sampleBlock = {
                $id: "id",
                style: (0, StyleBuilder_util_spec_1.getTextStyle)(colors),
            };
            sampleBlock.style.background = {
                themeIndex: 0,
                abs: colors[0],
            };
            var h1Color = (0, ColorUtils_1.shouldUseDarkText)(colors[0]) ? DefaultColors_1.DEFAULT_MIDNIGHT : DefaultColors_1.DEFAULT_WHITE;
            sampleBlock.style.h1.color = {
                themeIndex: h1Color.themeIndex,
                abs: h1Color.value,
            };
            return new BlockStore_1.default(sampleBlock);
        };
        _this.sampleBlockStore = _this.getSampleBlockStore();
        return _this;
    }
    StylePermissionsPreview.prototype.render = function () {
        var _a = this.props, stylePermissionStore = _a.stylePermissionStore, usingFeature = _a.usingFeature, brandStore = _a.brandStore;
        var style = this.sampleBlockStore.blockStyleStore.model;
        return (react_1.default.createElement("div", { className: "style-permissions-preview", style: { backgroundColor: style.background.abs } },
            react_1.default.createElement("div", { className: "style-permissions-preview__block-page" },
                react_1.default.createElement("div", { className: "style-permissions-preview__block-menu" },
                    react_1.default.createElement(exports.MenuButtons, { brandStore: brandStore, blockStore: this.sampleBlockStore, shouldShowBlockStyleButton: stylePermissionStore.isStyleShortcutAccessOn, shouldShowBlockBackgroundStyleButton: usingFeature(FeatureFlag_1.FeatureFlag.TextBlockBackgroundStylingMenu) &&
                            stylePermissionStore.isStyleAccessOn(Types_1.StyleAccessType.Block) }),
                    stylePermissionStore.isStyleShortcutAccessOn && this.renderSampleStyleShortcut()),
                react_1.default.createElement("div", { className: "permission__block-content" },
                    react_1.default.createElement("div", { className: "style-permissions-preview__block-sample-text", style: { color: style.h1.color.abs } },
                        react_1.default.createElement("span", { className: "block-sample-text--highlighted" }, "Introduction"),
                        " ---a little overview"))),
            react_1.default.createElement("div", { className: "style-permissions-preview__overlay" })));
    };
    StylePermissionsPreview = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], StylePermissionsPreview);
    return StylePermissionsPreview;
}(react_1.default.Component));
exports.StylePermissionsPreview = StylePermissionsPreview;
exports.default = StylePermissionsPreview;
